import React, { FC } from 'react';
import { STATUS } from 'model/global';
import { StatusSelect, Scheduled, Cancelled, Spinner } from './styles';
import { Props } from './types';

const StatusButton: FC<Props> = ({
  variant,
  isLoading,
  value,
  onChange,
  ...props
}) => {
  if (isLoading) {
    return (
      <Scheduled>
        <Spinner />
      </Scheduled>
    );
  }
  if (value.key === 'CANCELLED') {
    return <Cancelled>{value.caption}</Cancelled>;
  }

  if (value.key === 'SCHEDULED') {
    return <Scheduled>{value.caption}</Scheduled>;
  }

  let options = [
    { label: STATUS.COMPLETE.caption, value: STATUS.COMPLETE.key },
  ];

  if (value.key === 'READY') {
    options = [
      { label: STATUS.READY.caption, value: STATUS.READY.key },
      { label: STATUS.COMPLETE.caption, value: STATUS.COMPLETE.key },
    ];
  }
  if (value.key === 'PENDING') {
    options = [
      { label: STATUS.PENDING.caption, value: STATUS.PENDING.key },
      { label: STATUS.READY.caption, value: STATUS.READY.key },
      { label: STATUS.COMPLETE.caption, value: STATUS.COMPLETE.key },
    ];
  }

  return (
    <StatusSelect
      value={value.key}
      onChange={onChange}
      options={options}
      {...props}
    />
  );
};

export default StatusButton;
